import React from 'react';
import { Redirect, useLocalSearchParams, type Href } from 'expo-router';

import { ROUTES } from '../../src/navigation/routes';

/**
 * Old Progress → session link. The per-session report now lives on the
 * canonical report route (D0, CORE-4); keep old links and bookmarks working.
 */
export default function SessionDetailRedirect() {
  const params = useLocalSearchParams<{ sessionId?: string | string[] }>();
  const sessionId = Array.isArray(params.sessionId) ? params.sessionId[0] : params.sessionId;
  if (!sessionId) return <Redirect href={ROUTES.TABS_PROGRESS as Href} />;
  return <Redirect href={{ pathname: ROUTES.REPORT, params: { sessionId } } as Href} />;
}
